// extracted by mini-css-extract-plugin
export default {"fields":"ToolCustomFields_fields__WCJYr"};